import { action, observable } from 'mobx';

import { getAMACalculationRule } from './Service';

class AMACalculationRuleStore {
  @observable loading = true;
  @observable data = null;

  @observable filter = '';
  @observable sortDirection = 'ascending';
  @observable keyword = '';
  @observable sortColumn = 'CalculationName';
  @observable sortKey = 'CalculationName';
  @observable totalItems = 0;

  @observable curPage = 1;
  @observable pageSize = 20;
  @observable totalPage = 0;

  @observable open = false;
  @observable modalParams = {};
  @observable listPercentages = [];
  @observable errors = {};

  //Add caculationRule
  @observable lstAMACodeFrom = [];
  @observable lstAMACodeTo = [];
  @observable lstCalculationRule = [];
  @observable lstHistories = [];

  @action setFieldsValue = obj => {
    Object.keys(obj).forEach(key => {
      this[key] = obj[key];
    });
  };

  @action setPercentages = obj => {
    this.listPercentages = obj;
  };

  @action setListAMACodeFrom = arr => {
    this.lstAMACodeFrom = arr;
  };

  @action setListAMACodeTo = arr => {
    this.lstAMACodeTo = arr;
  };

  @action setListCalculationRule = arr => {
    this.lstCalculationRule = arr;
  };

  @action setListHistory = arr => {
    this.lstHistories = arr;
  };

  @action addErrors = (name, message) => {
    this.errors[name] = message;
  };

  @action removeError = name => {
    delete this.errors[name];
  };

  @action fetchData = (setTotalPage = false) => {
    this.loading = true;
    Promise.all([
      getAMACalculationRule(
        this.keyword,
        this.curPage,
        this.pageSize,
        this.sortKey,
        this.sortDirection.replace('ending', '').toUpperCase(),
      ),
    ])
      .then(
        action(([resp]) => {
          if (resp.curPage <= 1) {
            this.totalPage = resp.sumPage;
            this.totalItems = resp.sumItem;
          }
          this.data = resp;
          this.loading = false;
        }),
      )
      .catch(() => {});
  };

  @action handleSort = ({ sortKey }, { column, direction }) => {
    this.sortColumn = column;
    this.sortDirection = direction;
    this.sortKey = sortKey;
    this.fetchData();
  };

  @action refetch = (data, setTotalPage) => {
    Object.keys(data).forEach(key => {
      this[key] = data[key];
    });
    this.fetchData(setTotalPage);
  };

  toggleModal = (isOpen, params = {}) => {
    return action(() => {
      this.open = isOpen;
      this.modalParams = params;
    });
  };

  @action resetStore = () => {
    this.keyword = '';
    this.sortColumn = 'Id';
    this.sortKey = 'Id';
    this.sortDirection = 'ascending';

    this.curPage = 1;
    this.totalPage = 0;
    this.fetchData(true);
  };
}

export default new AMACalculationRuleStore();
